import React from "react";
import { Badge } from "@/components/ui-kit";
import { JOB_STATUSES, PRIORITIES, findMeta, fmtDate } from "@/lib/constants";
import { QrCode, Tags, ChevronRight, Layers } from "lucide-react";

const iconBtn = "flex h-10 w-10 items-center justify-center rounded-lg border border-border active:bg-accent";

export function MobileJobCards({ rows, onOpen, onLabel, onBatchLabel, onUnitLabels, onExpand }) {
  if (!rows.length) return <div className="py-10 text-center text-sm text-muted-foreground md:hidden">No job cards found.</div>;
  return (
    <div className="space-y-2 md:hidden" data-testid="mobile-job-cards">
      {rows.map((r) => {
        const j = r.job;
        const pr = findMeta(PRIORITIES, j.priority);
        if (r.kind === "batch") {
          const counts = r.items.reduce((a, x) => { a[x.status] = (a[x.status] || 0) + 1; return a; }, {});
          return (
            <div key={j.batch_id} className="rounded-xl border border-border bg-card p-3" data-testid={`m-batch-${j.batch_id}`}>
              <div className="flex items-start gap-2">
                <button className="min-w-0 flex-1 text-left" onClick={onExpand} data-testid={`m-batch-expand-${j.batch_id}`}>
                  <div className="flex items-center gap-1 font-mono text-xs text-primary"><Layers size={12} /> {j.batch_number} · {r.items.length} units</div>
                  <div className="truncate font-semibold">{j.equipment_name}</div>
                </button>
                <button className={iconBtn} onClick={() => onBatchLabel(r.items)} aria-label="Batch label" data-testid={`m-batch-qr-${j.batch_id}`}><QrCode size={16} /></button>
                <button className={iconBtn} onClick={() => onUnitLabels(r.items)} aria-label="Unit labels" data-testid={`m-batch-unit-labels-${j.batch_id}`}><Tags size={16} /></button>
              </div>
              <div className="mt-2 flex flex-wrap gap-1">
                {Object.entries(counts).map(([s, n]) => { const st = findMeta(JOB_STATUSES, s); return <Badge key={s} className={st.cls}>{n} {st.label}</Badge>; })}
              </div>
            </div>
          );
        }
        const st = findMeta(JOB_STATUSES, j.status);
        return (
          <div key={j.id} className="flex items-center gap-2 rounded-xl border border-border bg-card p-3" data-testid={`m-job-${j.id}`}>
            <button className="min-w-0 flex-1 text-left" onClick={() => onOpen(j)}>
              <div className="flex items-center justify-between gap-2">
                <span className="font-mono text-xs text-primary">{j.job_number}</span>
                <Badge className={st.cls}>{st.label}</Badge>
              </div>
              <div className="truncate font-semibold">{j.equipment_name}</div>
              <div className="flex items-center gap-2 font-mono text-[11px] text-muted-foreground">
                <span className="truncate">SN {j.serial_number}</span>·<span className={`font-bold ${pr.cls}`}>{pr.label}</span>·<span>{fmtDate(j.received_at)}</span>
              </div>
            </button>
            <button className={iconBtn} onClick={() => onLabel(j)} aria-label="QR label" data-testid={`m-qr-${j.id}`}><QrCode size={16} /></button>
            <ChevronRight size={16} className="text-muted-foreground" />
          </div>
        );
      })}
    </div>
  );
}
